import React from 'react'
import Svg from 'assets/facebook.svg'
import ContactButton from './ContactButton'

export default () => (
  <ContactButton href="https://www.facebook.com/ya.tsaryk" svgId={Svg.id!} tooltip="Facebook" />
)
